import React from 'react'
import { IconField } from "primereact/iconfield";
import { InputText } from 'primereact/inputtext';

const InputFieldIconText = ({ value, onChange, label, errorMessage, inputIcon, onBlur }) => {
  return (
    <div>
      <IconField iconPosition="left">
        <InputText value={value} onChange={onChange} placeholder={label} onBlur={onBlur} id={label}/>
      </IconField>
      {errorMessage && 
        <small id="text-help" style={{ color: 'red' }}>
          {errorMessage}
        </small>}
    </div>
  )
}

export default InputFieldIconText;